var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.initialized)?_c('blog-entries',{attrs:{"type":_vm.type,"entries":_vm.entries[_vm.type].list}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }